import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "tracekms",
    defaultRoutePath: "/cars/tracekm",
    menuItemScope: "fleet",
    menuItemName: "tracekms",

    routes: [
        {
            path: "/cars/tracekm",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "createUnrelated",
            Component: Wizards.CreateUnrelated,
        }
    ],

}

export default Module;
